const SUBSCRIPTION_STORAGE_KEY = "selectedSubscription";

export const findAzureVirtualMachineNameField = (formConfig) => {
  const isVmName = (name) =>
    ["virtualmachinename", "vmname"].includes(
      String(name ?? "").toLowerCase().replace(/[^a-z]/g, "")
    );

  return formConfig.find((field) => isVmName(field.fieldName)) ??
    formConfig.find((field) => isVmName(field.fieldLabel));
};

export const getAzureSubscriptionId = () => {
  const subscriptionId = sessionStorage.getItem(SUBSCRIPTION_STORAGE_KEY);

  if (!subscriptionId || !subscriptionId.trim()) {
    throw new Error("Please select an Azure subscription before continuing.");
  }

  return subscriptionId;
};

export const getAzureFormDefaults = (formConfig) => {
  const subscriptionFields = formConfig.filter(field =>
    [field.fieldName, field.fieldLabel].some(name =>
      ["subscription", "subscriptionid"].includes(
        String(name ?? "").toLowerCase().replace(/[^a-z]/g, "")
      )
    )
  );
  if (!subscriptionFields.length) {
    return {};
  }

  const subscriptionId = getAzureSubscriptionId();
  return Object.fromEntries(
    subscriptionFields.map(field => [
      field.fieldName,
      { value: subscriptionId, label: subscriptionId },
    ])
  );
};
